<template>
  <div>
    <h1 class="mb-1 text-2xl uppercase">
        Bun venit, <span class="font-bold">{{ $page.auth.user.first_name }}!</span>
    </h1>
    <h2 class="mb-8 text-lg text-gray-700">
        Mai jos puteți vedea informații despre cont, adrese, și comenzile plasate.
    </h2>


    <div class="flex flex-row border-b mb-8">
      <a :href="route('account.home')" :class="{ 'border-b-4 -mb-1 border-gray-800' : url() == 'account' }" class="px-3 md:px-6 py-2 cursor-pointer hover:border-b-4 hover:-mb-1 hover:border-gray-800 transition ease-in-out duration-150">
        Profil
      </a>
      <inertia-link :href="route('shop.account.addresses')" :class="{ 'border-b-4 -mb-1 border-gray-800' : url().includes('addresses')}" class="px-3 md:px-6 py-2 cursor-pointer hover:border-b-4 hover:-mb-1 hover:border-gray-800 transition ease-in-out duration-150">
        Adrese
      </inertia-link>
      <inertia-link :href="route('shop.account.orders')" :class="{ 'border-b-4 -mb-1 border-gray-800' : url().includes('orders') }" class="px-3 md:px-6 py-2 cursor-pointer hover:border-b-4 hover:-mb-1 hover:border-gray-800 transition ease-in-out duration-150">
        Comenzi
      </inertia-link>
    </div>

    <slot />
  </div>
</template>

<script>

export default {
  methods: {
    url() {
      return location.pathname.substr(1)
    },
  }
}
</script>
